<template>
	<div class="sideways-page-one">
		<!-- BEGIN PAGE BAR -->
		<div class="page-bar">
			<breadcrumb :crumbs="breadcrumbArray"></breadcrumb>
		</div>
		<!-- <h1 class="page-title">Layout</h1> -->
		<div v-if="step === 0" class="flex-center" >
			<div>
				<h1> Layouts </h1>
			</div>
			<div>
				<el-button @click="setStep(1)" style="width:25%" type="primary"> Create a new Layout</el-button>
				<el-button @click="setStep(2), getLayouts()" style="width:25%" type="primary"> Open existing layout</el-button>
			</div>
		</div>
		<div v-if="step === 1" class="flex-center" >
			<div>
				<h1 v-if="type === 0"> Create new layout </h1>
				<h1 v-if="type === 1"> Edit layout Region: {{ name }} ({{ this.displayCount }} screens)</h1>
			</div>
			<div v-if="type === 1">
				<h2> Click on a screen below to edit its regions</h2>
			</div>
			<div v-if="type === 0">
				<el-input style="width:30%" placeholder="Layout name" v-model="name"></el-input>
			</div>
			<div v-if="type === 0">
				<el-button @click="setLayoutSize(1920, 1080)" style="width:15%" type="primary"> Horizontal (1920 x 1080)</el-button>
				<el-button @click="setLayoutSize(1080, 1920)" style="width:15%" type="primary"> Vertical (1080 x 1920)</el-button>
			</div>
	<!-- 		<div>
				<el-input @change="syncWithVisual()" style="width:25%" placeholder="Height" v-model="visualHeight"></el-input>
				<el-input @change="syncWithVisual()" style="width:25%" placeholder="Width" v-model="visualWidth"></el-input>
			</div> -->
			<div v-if="type === 0">
				 Number of screens <el-input-number v-model="displayCount" :min="1" ></el-input-number>
			</div>
			<div v-if="type === 0">
				<el-button @click="createLayout()" style="width:8%" type="primary"> Save </el-button>
				<el-button @click="setStep(0)" style="width:8%" type="primary"> Cancel </el-button>
			</div>
		<!-- 	<div>
				<div style="display:flex;justify-content:center;align-items:center;">
					<el-slider style="width:25%" v-model="scale" :step="0.1" show-input :min="0.1" :max="1"></el-slider>
				</div>
			</div> -->
			<div v-if="type === 1" @click="setStep(3, 0, i), displayNumber = i" v-for="(n, i) in displayCount" style="position:relative;display:flex;width:auto!important;margin:0" class="hoverDisplay">
				<div id="text-area" style="outline:1px solid black;" disabled :style="{width: layoutWidth / 60 + 'vw', height: layoutHeight / 60 + 'vw'}">
					<div v-if="zone.screen === i" v-for="zone in regionList" disabled style="position:absolute" :style="{top: zone.y / 60 + 'vw', left: zone.x / 60 + 'vw', width: zone.width / 60 + 'vw', height: zone.height / 60 + 'vw', backgroundColor: zone.background}">
						<!-- {{ (i) * layoutWidth }} {{ zone.x}} -->
				</div>
				</div>
			</div>
			<div v-if="type === 0" v-for="(n, i) in displayCount" style="position:relative;display:flex;width:auto!important;margin:0" class="hoverDisplay">
				<div id="text-area" style="outline:1px solid black;" disabled :style="{width: layoutWidth / 60 + 'vw', height: layoutHeight / 60 + 'vw'}">
					<div v-if="zone.screen === i" v-for="zone in regionList" disabled style="position:absolute" :style="{top: zone.y / 60 + 'vw', left: zone.x / 60 + 'vw', width: zone.width / 60 + 'vw', height: zone.height / 60 + 'vw', backgroundColor: zone.background}">
						<!-- {{ (i) * layoutWidth }} {{ zone.x}} -->
				</div>
				</div>
			</div>
		</div>
		<div v-if="step === 2" class="flex-center" >
			<div>
				<h1> Select a layout </h1>
			</div>
			<div>
				<!-- {{ layoutList }} -->
				<template v-for="(layout, index) in layoutList">
					<el-button @click="setStep(1, 1), setActiveLayout(index)" style="width:25%" type="primary"> {{ layout.name }} w: {{layout.width}} h: {{layout.height}} </el-button>
					<el-button @click="deleteLayout(layout.layout_id, index)" type="danger"> Delete </el-button> 
					<br>
					<br>
				</template>
			</div>
		</div>

		<div v-if="step === 3" class="flex-center" >
<!-- 			<div>
				<h1> Layout Editor (Display {{ displayNumber + 1 }}/{{ displayCount }}) </h1>
				{{ layoutWidth }} x {{ layoutHeight }}
			</div> -->
			<div>
				<div>
					<h1> {{ name }} (Display {{ displayNumber + 1 }}/{{ displayCount }})</h1>
				</div>
				<button :disabled="!displayNumber > 0" @click="prevDisplay()" class="button btn">
					<i class="fa fa-chevron-left fa-2x"></i>
					<br>
					Previous Display
				</button>
				<button @click="toggle()" class="button btn">
					<i class="fa fa-arrows-alt fa-2x"></i>
					<br>
					Fullscreen
				</button>
				<button :disabled="!(this.displayNumber < this.displayCount - 1)" @click="nextDisplay()" class="button btn">
					<i class="fa fa-chevron-right fa-2x"></i>
					<br>
					Next Display
				</button>
			</div>
			<div>
				<div style="display:flex;justify-content:center;align-items:center;">
					<span class="demonstration">Zoom: </span>
					<el-slider style="width:25%" @change="updatePadding" v-model="scale" :step="0.1" show-input :min="0.1" :max="1"></el-slider>
				</div>
			</div>
			<span class="demonstration">Grid Size:  </span>
			<el-slider style="width:25%" v-model="grid" :step="5" show-input :min="5" :max="20"show-stops></el-slider>

<!-- 			<div>
				<button type="button" style="background-color:red" @click="toggle()" >Fullscreen</button>
			</div> -->
			<div style="width:100%">
			</div>
			<div style="width:50%">
				<div style="width:100%">
						<h1> Toolbox </h1>
					</div>
				<div style="margin-bottom: 2px">
					<button @click="updateZones()" class="button btn">
					  <i class="fa fa-save fa-2x "></i>
					  <br>
					  Save
					</button>

<!-- 					<button @click="deleteRegion()" class="button btn">
					  <i class="fa fa-trash fa-2x"></i>
					  <br>
					  Delete selected Region
					</button> -->

<!-- 					<button @click="setStep(1)" class="button btn">
					  <i class="fa fa-ban fa-2x"></i>
					  <br>
					  Delete layout
					</button> -->

					<button @click="setStep(1, 1), getZones()" class="button btn">
					  <i class="fa fa-th fa-2x"></i>
					  <br>
					  MultiView
					</button>

<!-- 					<button @click="toggle()" class="button btn">
					  <i class="fa fa-arrows-alt fa-2x"></i>
					  <br>
					  Fullscreen
					</button> -->
				</div>
			</div>
			<div style="width:25%">
				<div style="width: 100%;display:flex;justify-content:center;align-items:center;flex-wrap:wrap">
					<div style="width:100%">
						<h1> Layers </h1>
					</div>
					<div style="width:100%">
						<button @click="addNewRegion()" class="button btn primary"> Add region </button>
						<button @click="deleteRegion()" class="button btn primary"> Delete region </button>
					</div>
					<draggable @end="onEnd">
						<div @click="selectRegion(i)" v-if="region.background !== 'transparent'  && region.screen === displayNumber" v-for="(region, i) in regionList" :id="'minimap-' + i" :style="{'background-color': region.background}" :class="{'selectedBlock': i === selectedRegion}" style="display:inline-block:float:left;color:white;padding: 5px">
							{{ region.name }} 
							{{ region.width }}x{{ region.height }}
<!-- 								<a style="position: relative;right: -20px;" @click="deleteRegion(i)">
								  <i class="fa fa-trash fa-inverse" style="color:red"></i>
								</a> -->
						</div>
					</draggable>
				</div>
			</div>
			<div style="width: auto!important;padding: 5px;" :style="{'margin-bottom': padding + 'px'}">
				<fs ref="fs" :fullscreen.sync="fullscreen">
					<div class="layout-editor" style="background-image: linear-gradient(to right, lightgrey 1px, transparent 1px), linear-gradient(to bottom, lightgrey 1px, transparent 1px);position: relative;transform-origin:top;outline: 5px solid black;" :style="{width: layoutWidth + 'px', height: layoutHeight + 'px', transform: 'scale(' + scale + ',' + scale + ')', 'background-size': grid + 'px ' + grid + 'px'}">
						<template v-if="region.background !== 'transparent' && region.screen === displayNumber" v-for="(region, i) in regionList">
							<vue-draggable-resizable :grid="[grid, grid]" :style="{'background-color': region.background}" :id="`region-${i}`" :index="i" @activated="selectRegion(i)" class="region" :x="region.x" :y="region.y" :w="region.width" :h="region.height" :z="region.z" v-on:dragging="onDrag" v-on:resizing="onResize" :parent="true">
							<span style="background-color:rgba(0,0,0,0.5);color:white;border-radius: 4px;padding:2px;">
								top:{{ region.y }} left:{{ region.x }} <br>
								{{ region.width }}w {{ region.height }}h <br>
								<!-- {{ region.z }}z -->
							</span>
					   		</vue-draggable-resizable>
						</template>
					</div>
				</fs>
			</div>
		</div>
	</div>
</template>

<script>
	import Breadcrumb from '../../modules/Breadcrumb'
	import $ from 'jquery'
	import VueDraggableResizable from '../../modules/vue-draggable-resizable'
	import Fullscreen from 'vue-fullscreen'
	import Vue from 'vue'
	import draggable from 'vuedraggable'
	import Signage from '../../../controllers/Signage'
	import md5 from 'md5'
	import {mapGetters} from 'vuex'

	Vue.use(Fullscreen, {name: 'fs'})
	export default {
		data () {
			return {
				step: 0,
				note: 'Signage Layout',
				breadcrumbArray: [
					{name: 'UNOapp Signage', link: false},
					{name: 'Layout', link: false}
				],
				displayCount: 1,
				layoutHeight: 1080,
				layoutWidth: 1920,
				visualHeight: 1080,
				visualWidth: 1920,
				regionList: [],
				dragndrop: [],
				selectedRegion: 0,
				scale: 0.5,
				fullscreen: false,
				beforeFullscreen: null,
				grid: 10,
				miniMap: [],
				layoutList: [],
				type: 0,
				name: '',
				padding: 60,
				layoutId: 0,
				displayNumber: 0,
				deleteRegions: []
			}
		},
		computed: mapGetters([
			'activeLocationId'
		]),
		mounted () {
			window.addEventListener('keyup', this.keypress)
			// this.colorHash()
		},
		methods: {
			prevDisplay () {
				if (this.displayNumber > 0) {
					this.displayNumber--
					this.getZones()
				}
			},
			nextDisplay () {
				if (this.displayNumber < this.displayCount - 1) {
					this.displayNumber++
					this.getZones()
				}
			},
			setActiveLayout (index) {
				if (this.layoutList[index].width % 1080 === 0) {
					this.layoutWidth = 1080
					this.layoutHeight = 1920
					this.padding = -(this.layoutHeight * (1 - this.scale)) + 20
					this.displayCount = this.layoutList[index].width / 1080
				} else {
					this.layoutWidth = 1920
					this.layoutHeight = 1080
					this.padding = -(this.layoutHeight * (1 - this.scale)) + 20
					this.displayCount = this.layoutList[index].width / 1920
				}
				this.layoutId = this.layoutList[index].layout_id
				this.name = this.layoutList[index].name
				this.getZones()
			},
			updatePadding (val) {
				this.padding = -(this.layoutHeight * (1 - val)) + 20
			},
			updateZones () {
				var zeroIndex = false
				this.regionList.forEach(x => {
					if (x.z === 0) {
						zeroIndex = true
					}
				})
				if (zeroIndex) {
					this.regionList = this.regionList.map(x => {
						let obj = x
						x.z++
						return obj
					})
				}
				this.regionList.forEach(x => {
					if (x.screen === this.displayNumber) {
						let obj = {
							width: x.width,
							height: x.height,
							z_index: x.z,
							x: x.x + (this.displayNumber * this.layoutWidth),
							y: x.y,
							label: x.name,
							zone_id: x.zone_id,
							layout_id: this.layoutId
						}
						return Signage.updateZones(obj).then(response => {
							this.$notify({
								title: 'Success',
								message: 'Successfully Updated Zone: ' + x.name,
								type: 'success'
							})
						}).catch(e => {
							this.$notify.error({
								title: 'Error',
								message: e
							})
						})
					}
				})
			},
			createZone (region) {
				let obj = {
					layout_id: this.layoutId,
					label: region.name,
					width: region.width,
					height: region.height,
					x: region.x + this.layoutWidth * this.displayNumber,
					y: region.y,
					z_index: region.z
				}
				return Signage.createZone(obj).then(response => {
					console.log(response)
					this.getZones()
				}).catch(e => {
					this.$notify.error({
						title: 'Error',
						message: e.responseJSON.payload.label[0]
					})
				})
			},
			deleteZone (id) {
				return Signage.deleteZone(id).then(response => {
					console.log(response)
				}).catch(e => {
				})
			},
			getZones () {
				this.regionList = []
				return Signage.getZones(this.layoutId).then(response => {
					let temp = response.payload.zones.map(x => {
						let obj = {
							width: x.width,
							height: x.height,
							z: x.z_index,
							y: x.y,
							x: x.x - (((x.x / this.layoutWidth) >> 0) * this.layoutWidth),
							background: this.colorHash(x.label, x.zone_id),
							name: x.label,
							zone_id: x.zone_id,
							screen: (x.x / this.layoutWidth) >> 0
						}
						console.log(obj)
						return obj
					})
					this.regionList = temp.sort((a, b) => {
						return parseFloat(b.z) - parseFloat(a.z)
					})
				}).catch(e => {
				})
			},
			createLayout () {
				let obj = {
					location_id: this.activeLocationId,
					name: this.name,
					width: this.layoutWidth * this.displayCount,
					height: this.layoutHeight
				}
				return Signage.createLayout(obj).then(response => {
					console.log(response)
					this.getLayouts()
					this.setStep(2)
				}).catch(e => {
				})
			},
			deleteLayout (id, index) {
				return Signage.deleteLayout(id).then(response => {
					console.log(response)
					this.layoutList.splice(index, 1)
				}).catch(e => {
				})
			},
			getLayouts () {
				return Signage.getLayouts(this.activeLocationId).then(response => {
					console.log(response)
					this.layoutList = response.payload.layouts
				}).catch(e => {
				})
			},
			selectRegion (val) {
				this.selectedRegion = val
				for (let i = 0; i < this.regionList.length - 1; i++) {
					if (this.regionList[i].background === 'transparent') {
						this.regionList.splice(i, 1)
						break
					}
				}
			},
			onEnd (e) {
				let arr = Array.from(e.to.children)
				arr.forEach((x, i) => {
					this.regionList[parseInt(x.id.substr(-1))].z = Math.abs(i - (arr.length - 1))
				})
			},
			keypress (e) {
				// if (this.step === 3) {
				// 	if (e.key === 'n') {
				// 		this.addNewRegion()
				// 	} else if (e.key === 'Backspace') {
				// 		this.deleteRegion()
				// 	}
				// }
			},
			toggle () {
				this.$refs.fs.toggle()
				this.$fs.toggle(this.$el.querySelector('.layout-editor'), {
					wrap: true,
					background: 'white',
					callback: this.fullscreenChange
				})
			},
			fullscreenChange (fullscreen) {
				console.log(fullscreen)
				this.fullscreen = fullscreen
				if (fullscreen === true && this.beforeFullscreen === null) {
					console.log(this.scale)
					this.beforeFullscreen = this.scale
					this.scale = 1
					console.log(this.beforeFullscreen)
				} else if (fullscreen === false && this.beforeFullscreen !== null) {
					this.scale = this.beforeFullscreen
					this.beforeFullscreen = null
				}
			},
			colorHash (name, id) {
				var str = md5(id + name)
				console.log(str)
				var bytes = [] // char codes
				for (var i = 0; i < str.length; ++i) {
					var code = str.charCodeAt(i)
					bytes = bytes.concat([code])
				}
				var bytesTotal = bytes.reduce((total, x) => {
					total += x
					return total
				}, 0)
				var val = bytesTotal / bytes.length
				var normalize = val / 255
				var normalize2 = normalize * 10 / 9
				console.log(normalize)
				return `#${Math.floor(normalize2 * 0x1000000).toString(16).padStart(6, 0)}`
			},
			test () {
				if (this.selectedRegion !== null) {
					this.selectedRegion = null
				}
				console.log('test')
			},
			deleteRegion () {
				console.log(this.selectedRegion)
				console.log(this.regionList)
				if (this.selectedRegion !== null) {
					this.deleteZone(this.regionList[this.selectedRegion].zone_id)
					this.regionList[this.selectedRegion].background = 'transparent'
					// this.regionList.splice(this.selectedRegion, 1)
					// this.regionList = this.regionList.map((x, i) => {
					// 	if (i !== this.selectedRegion) {
					// 		return x
					// 	}
					// })
					let count = this.regionList.reduce((t, x) => {
						if (x.background !== 'transparent') {
							t++
						}
						return t
					}, 0)
					if (count === 0) {
						this.regionList = []
					}
					this.selectedRegion = null
				}
			},
			addNewRegion () {
				this.$prompt('Name this Zone', 'Zone', {
					confirmButtonText: 'OK',
					cancelButtonText: 'Cancel',
					inputErrorMessage: 'Invalid Email'
				}).then(value => {
					this.regionList = this.regionList.map(x => {
						let obj = x
						x.z++
						return obj
					})
					this.updateZones()
					let obj = {
						height: 100,
						width: 100,
						x: 0,
						y: 0,
						z: 1,
						background: 'transparent',
						name: value.value
					}
					this.createZone(obj)
				}).catch(() => {
				})
				// const index = this.regionList.length - 1
				// $('#region-' + index).css('background-color', this.getRandomColor())
			},
			onResize (x, y, width, height, i) {
				this.selectedRegion = i
				let r = this.regionList[i]
				r.x = x
				r.y = y
				r.width = width
				r.height = height
			},
			onDrag (x, y, w, h, i, p) {
				this.selectedRegion = i
				let r = this.regionList[i]
				r.x = x
				r.y = y
			},
			setStep (val, type = 0, i) {
				// if (val === 3) {
				// 	this.getZones()
				// }
				this.step = val
				this.type = type
			},
			setLayoutSize (width, height) {
				this.layoutHeight = height
				this.layoutWidth = width
			},
			syncWithVisual () {
				this.layoutWidth = this.visualWidth
				this.layoutHeight = this.visualHeight
			},
			getVisualPosition (id) {
				const width = $(window).innerWidth()
				if (id !== null) {
					return [Math.floor((($(id).position().top / width * 100) * 60)), Math.floor(($(id).position().left / width * 100) * 60)]
				} else {
					return false
				}
			},
			getVisualDimensions (id) {
				const width = $(window).innerWidth()
				if (id !== null) {
					const w = Math.floor(($(id).css('width').slice(0, -2) / width * 100) * 60)
					const h = Math.floor(($(id).css('height').slice(0, -2) / width * 100) * 60)
					return [w, h]
				} else {
					return false
				}
			}
			// handleRegionResize () {
				// console.log('region resize')
				// const width = $(window).innerWidth()
				// this.regionWidth = +(+$('#region-area').css('width').slice(0, -2) / width * 100).toFixed(0)
				// this.regionHeight = +(+$('#region-area').css('height').slice(0, -2) / width * 100).toFixed(0)

				// let maxwidth = 1920 / 60
				// let maxheight = 1080 / 60
				// if (+(+$('#region-area').css('width').slice(0, -2) / width * 100).toFixed(0) * 60 <= maxwidth) {
				// 	this.regionWidth = +(+$('#region-area').css('width').slice(0, -2) / width * 100).toFixed(0)
				// } else {
				// 	this.regionWidth = maxwidth
				// }
				// if (+(+$('#region-area').css('height').slice(0, -2) / width * 100).toFixed(0) * 60 <= maxheight) {
				// 	this.regionHeight = +(+$('#region-area').css('height').slice(0, -2) / width * 100).toFixed(0)
				// } else {
				// 	this.regionHeight = maxheight
				// }
			// },
			// handleResize () {
			// 	const width = $(window).innerWidth()
			// 	this.visualWidth = Math.round(($('#text-area').css('width').slice(0, -2) / width * 100) * 60)
			// 	this.visualHeight = Math.round(($('#text-area').css('height').slice(0, -2) / width * 100) * 60)
			// }
		},
		components: {
			Breadcrumb,
			VueDraggableResizable,
			draggable
		}
	}
</script>
<style>
.vdr.active {
	opacity: 1 !important;
}
.hoverDisplay:hover {
	opacity: 0.5;
	cursor:pointer;
}
.fullscreen {
	display: flex;
	justify-content: center;
	align-items: center;
}
.handle-tl {
	left: 0 !important;
	top: 0 !important;
}
.handle-tr {
	top: 0 !important;
	right: 0 !important;
}
.handle-tm {
	top: 0 !important;
}
.handle-bm {
	bottom: 0 !important;
}
.handle-mr {
	right: 0 !important;
}
.handle-ml {
	left: 0 !important;
}
.handle-br {
	bottom: 0 !important;
	right: 0 !important;
}
.handle-bl {
	bottom: 0 !important;
	left: 0 !important;
}
</style>
<style scoped>
.region {
	opacity:0.8;
	justify-content:center;
	display:flex;
	align-items:center;
	text-align:center;
	/*border: 2px dotted grey;*/
/*	background-color:lightgrey;*/
}
#draggable { width: 150px; height: 150px; padding: 0.5em; }
.flex-center {
	width:100%;
	display:flex;
	justify-content:center;
	align-items:center;
	flex-wrap:wrap;
	text-align:center;
}
.flex-center > div {
	width: 100%;
	margin: 5px;
}
.el-button+.el-button {
    margin-left: 0px !important;
}
.selectedBlock {
	border: 2px solid black;
}
</style>


// WEBPACK FOOTER //
// Layout.vue?631ec638